import  {createStore} from 'vuex'

import user from './modules/user'
import menu from  './modules/menu'
import system from './modules/system.js' 
import {getters} from './getters.js'
const store = createStore({
  modules:{
    user,
    menu, 
    system,
  },
  getters
})

export default store
